import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Snackbar } from '../components/snackbar';
import { LOADING, COMPLETE, JOBS_GET_OK, JOB_UPDATE_OK, JOB_DELETE_OK, JOB_TERMINATE_OK, JOB_SET_PROGRESS, SAVING, JOB_GET_WITH_CLIENT_OK } from './types';
import { call } from './../utilities/http';

const defaultState = {
    list: undefined,
    withClientInfo: undefined
};

/**
 * Loading state mapper.
 * @param {object} state
 * @param {string} action
 */
export default function(state = defaultState, action) {
    switch (action.type) {
        case JOBS_GET_OK:
            return { ...state, list: action.data };

        case JOB_GET_WITH_CLIENT_OK:
            const { job } = action.data;
            const withClientInfo = state.withClientInfo ? { ...state.withClientInfo } : {};
            withClientInfo[job.id] = action.data;
            return { ...state, withClientInfo };

        case JOB_DELETE_OK:
            return state;

        case JOB_SET_PROGRESS:
            const { progress, id } = action.data;
            if (state.list) {
                let jobs = state.list.filter(j => j.id !== id);
                let job = state.list.find(j => j.id === id);
                return { ...state, list: [...jobs, { ...job, progress }] };
            } else {
                return state;
            }

        default:
            return state;
    }
}

export function getJobs(role, onSuccess = response => null) {
    let errorMessage = <FormattedMessage id={'error.getJobs'} defaultMessage={'Unable to retrieve jobs.'} />;

    return async function(dispatch) {
        dispatch({ type: LOADING });
        const { id, type } = role;
        if (!id || !type) {
            Snackbar.error(errorMessage);
            dispatch({ type: COMPLETE });
            return;
        }

        call({ path: `/${type}/${id}/jobs?extended=true&limit=1000` })
            .then(response => {
                dispatch({ type: JOBS_GET_OK, data: response });
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                Snackbar.error(errorMessage);
                dispatch({ type: COMPLETE });
            });
    };
}

export function getJob(job, onSuccess = response => null) {
    let errorMessage = <FormattedMessage id={'error.getJob'} defaultMessage={'Unable to retrieve job details.'} />;

    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/job/${job.id}` })
            .then(response => {
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                Snackbar.error(errorMessage);
                dispatch({ type: COMPLETE });
            });
    };
}

export function deleteJob(job, onSuccess = response => null) {
    let errorMessage = <FormattedMessage id={'error.getJob'} defaultMessage={'Unable to retrieve job details.'} />;

    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/job/${job.id}`, method: 'DELETE' })
            .then(response => {
                dispatch({ type: JOB_DELETE_OK, data: response });
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                Snackbar.error(errorMessage);
                dispatch({ type: COMPLETE });
            });
    };
}

export function terminateJob(job, onSuccess = response => null) {
    let errorMessage = <FormattedMessage id={'error.terminateJob'} defaultMessage={'Unable to terminate assignment.'} />;

    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/job/${job.id}/action/terminate`, method: 'POST' })
            .then(response => {
                dispatch({ type: JOB_TERMINATE_OK, data: response });
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                Snackbar.error(errorMessage);
                dispatch({ type: COMPLETE });
            });
    };
}

export function getJobWithClientInfo(id, onSuccess = response => null) {
    let errorMessage = <FormattedMessage id={'error.getJobWithClientInfo'} defaultMessage={'Unable to retrieve job.'} />;
    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/job/${id}?client_info=true` })
            .then(response => {
                dispatch({ type: JOB_GET_WITH_CLIENT_OK, data: response });
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                Snackbar.error(errorMessage);
                dispatch({ type: COMPLETE });
            });
    };
}

export function updateJob(job, onSuccess = response => null) {
    let errorMessage = <FormattedMessage id={'error.updateJob'} defaultMessage={'Unable to update job record.'} />;

    return async function(dispatch) {
        dispatch({ type: SAVING });
        call({ path: `/job/${job.id}`, method: 'PUT', body: job })
            .then(response => {
                dispatch({ type: COMPLETE });
                dispatch({ type: JOB_UPDATE_OK, data: job });
                onSuccess(response);
            })
            .catch(error => {
                Snackbar.error(errorMessage);
                dispatch({ type: COMPLETE });
            });
    };
}

export function executeJobAction(jobId, action, onSuccess = response => null) {
    let errorMessage = <FormattedMessage id={'error.activateJob'} defaultMessage={'Unable to complete job onboarding.'} />;

    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/job/${jobId}/action/${action}`, method: 'POST' })
            .then(response => {
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                Snackbar.error(errorMessage);
                dispatch({ type: COMPLETE });
            });
    };
}

export function calculateRegime(jobId, onSuccess = response => null) {
    let errorMessage = <FormattedMessage id={'error.activateJob'} defaultMessage={'Unable to calculate job regime.'} />;

    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/job/${jobId}/calculate_regime` })
            .then(response => {
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                Snackbar.error(errorMessage);
                dispatch({ type: COMPLETE });
            });
    };
}

export function setJobProgress(id, progress) {
    return async function(dispatch) {
        dispatch({ type: JOB_SET_PROGRESS, data: { progress, id } });
    };
}



// WEBPACK FOOTER //
// ./src/reducers/jobs.jsx